export const link =
  "bg-orange-200 text-orange-900 shadow hover:shadow-lg  px-3 py-2 lg:px-4 lg:py-2 rounded clickable inline-flex items-center justify-center";
